import { useEffect } from "react";
import tokenService from "services/token.service";
import { useDisconnect } from "wagmi";

function useRegisterDisconnect() {
  const { disconnect } = useDisconnect();

  useEffect(() => {
    tokenService.registerDisconnectFn(disconnect);
  }, [disconnect]);
}

export default useRegisterDisconnect;
